import React from 'react'
import { Controller } from 'react-hook-form'

const Checklist = (props) => {
  const selectedClass = day => {
    return props.selected.find(e => e == day) ? 'selected' : ''
  }

  const toggleDay = day => {
    const days = props.selected
    return days.find(d => d == day) ? [...new Set(days.filter(d => d != day))] : [...new Set(days.concat(day))]
  }

  return <label className='league-label'>
    {props.label}
    <Controller
      control={props.control}
      name={props.name}
      render={({ field }) => (
        <div className='checklist-container'>
          {props.options.map(o => (
            <div className={`checklist-container__item ${selectedClass(o.id)}`}
              key={o.id}
              onClick={() => props.onChange(toggleDay(o.id))}
            >
              <span>{o.name}</span>
            </div>
          ))}
        </div>
      )}
    />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
}

export default Checklist
